module.exports = __webpack_public_path__ + "img/living_1.5b1ad893.jpg";